<template>
  <div id="app">
    <main-header></main-header>
    <router-view/>
    <CTABanner />
    <main-footer></main-footer>
  </div>
</template>

<script>
import MainHeader from '@/components/partials/MainHeader'
import MainFooter from '@/components/partials/MainFooter'
import CTABanner from '@/components/partials/CTABanner'

export default {
  name: 'App',
  metaInfo: {
    titleTemplate: '%s | Rococo Painters'
  },
  components: {
    MainHeader,
    MainFooter,
    CTABanner
  }
}
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=IBM+Plex+Sans:300,400,600,700');
  @import "../node_modules/bootstrap/scss/bootstrap.scss";
  @import "../src/assets/styles/main.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue